import React, { useState } from "react"

const navLinks = [
  { label: "Services", href: "/#services" },
  { label: "About", href: "/#about" },
  { label: "Contact", href: "/#contact" },
]

export default function Header() {
  const [isOpen, setIsOpen] = useState(false)

  const closeNav = () => setIsOpen(false)

  return (
    <header className="header">
      <div className="container fw header__inner">
        <a href="/" className="header__logo" aria-label="Jason Clixby, home">
          Jason Clixby <span>.</span>
        </a>

        <button
          className={`header__toggle${isOpen ? " is-open" : ""}`}
          aria-label={isOpen ? "Close menu" : "Open menu"}
          aria-expanded={isOpen}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`header__nav${isOpen ? " is-open" : ""}`}>
          <ul className="header__links">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a href={link.href} onClick={closeNav}>
                  {link.label}
                </a>
              </li>
            ))}
            <li className="header__cta">
              <a href="/#contact" className="btn filled" onClick={closeNav}>
                Get in touch
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}